// src/features/dashboard/mocks/timeAllocationChart.mock.ts

import type {
  TimeAllocationChartApiResponse,
  TimeAllocationChartItem,
} from '../types/timeAllocationChart.types';

/**
 * MOCK DATA
 */
export const timeAllocationChartMockData: TimeAllocationChartApiResponse[] = [
  {
    categoryName: 'Productive',
    percentage: 68,
    colorHex: '#22C55E',
    totalHours: 1240,
    totalAssociates: 150,
  },
  {
    categoryName: 'Neutral',
    percentage: 18,
    colorHex: '#FACC15',
    totalHours: 328,
    totalAssociates: 150,
  },
  {
    categoryName: 'Idle',
    percentage: 14,
    colorHex: '#EF4444',
    totalHours: 255,
    totalAssociates: 150,
  },
];

/**
 * MAP API RESPONSE
 */
export const mapTimeAllocationChartData = (
  response: TimeAllocationChartApiResponse[],
): TimeAllocationChartItem[] => {

  return response.map((item) => ({
    name: item.categoryName,

    value: item.percentage,

    color: item.colorHex,

    totalHours: item.totalHours,

    totalAssociates: item.totalAssociates,
  }));
};